@if (notification$ | async; as notification) {
  <div class="wrapper">
    @if (notification.type === NotificationBarNotificationType.embedded) {
      @switch (notification.embedded) {
        @case (NotificationBarEmbeddedNotification.dataExtract) {
          <mc-extract-notification (close)="close()"> </mc-extract-notification>
        }
        @case (NotificationBarEmbeddedNotification.dataTableExtract) {
          <mc-data-table-extract-notification (close)="close()"> </mc-data-table-extract-notification>
        }
      }
    } @else {
      <div class="dynamic-content row d-flex align-content-center">
        <div class="col-8 offset-2 text-center">
          {{ notification.message }}
        </div>
        <div class="col-2 text-right pe-5 close-text">
          <span (click)="close()">{{ closeText }}</span>
        </div>
      </div>
    }
  </div>
}
